export default "__VITE_ASSET__98108dc9__"